export default (isRefresh = false) => {
  const editor = process.env.VUE_APP_PROTOCOL ? "m3dHubEditor" : "kirinote";
  const token = localStorage.getItem(`${editor}__token`) || sessionStorage.getItem(`${editor}__token`);
  // 토큰이 없으면 null 리턴
  if (!token) return { Authorization: null };

  const Authorization = `Bearer ${localStorage.getItem(`${editor}__token`) || sessionStorage.getItem(`${editor}__token`)}`;
  // 토큰이 있으면 Bearer 붙여서 리턴
  return { Authorization };
};
